import "./RaikoBaseDialogContentContainer.scss"

export default function RaikoBaseDialogContentContainer({children}) {

    return(
        <section className="raikoBaseDialogContentContainer">
            {children}
        </section>
    )
}